import { render, staticRenderFns } from "./DraftSelectionList.vue?vue&type=template&id=3360a6d5"
import script from "./DraftSelectionList.vue?vue&type=script&lang=js"
export * from "./DraftSelectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports